import Box from "@/components/Box";
import Grid from "@/components/Grid";
import RichText from "@/components/RichText";
import Spacer from "@/tpo/Spacer";
import Stack from "@/tpo/Stack";
import { DISPLAY_CONTEXT_ALWAYS_VISIBLE, DISPLAY_CONTEXT_B2B_ONLY } from "@/tpo/shop/constants";

function SectionHeading({ children }) {
  return (
    <Box fontFamily="gilroyBold" fontSize={[18, 18, 24]}>
      {children}
    </Box>
  );
}

function getVisibleInformationPanels(panels) {
  return (panels || []).filter(
    panel =>
      panel.displayContext === DISPLAY_CONTEXT_ALWAYS_VISIBLE ||
      panel.displayContext === DISPLAY_CONTEXT_B2B_ONLY
  );
}

export default function CyrexAddOnExpandedContent({ description, informationPanels, biomarkersTested }) {
  const visiblePanels = getVisibleInformationPanels(informationPanels);

  return (
    <Stack gap={40} py={[15, 15, 30]} px={[20, 20, 40]} style={{ whiteSpace: "normal" }}>
      {description ? (
        <Box>
          <SectionHeading>Overview</SectionHeading>
          <Spacer py={[1, 1, 2]} />
          <RichText fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
            {description}
          </RichText>
        </Box>
      ) : null}
      {visiblePanels.map(panel => (
        <Box key={panel.id}>
          <SectionHeading>{panel.title}</SectionHeading>
          <Spacer py={[1, 1, 2]} />
          <RichText fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
            {panel.body}
          </RichText>
        </Box>
      ))}
      {biomarkersTested?.length ? (
        <Box>
          <SectionHeading>Biomarkers Tested</SectionHeading>
          <Spacer py={[1, 1, 2]} />
          <Grid
            as="ul"
            gridColumnGap={40}
            style={{
              listStylePosition: "inside",
              listStyleType: "disc",
              textIndent: "-13px",
              paddingLeft: "13px"
            }}
          >
            {biomarkersTested.map(biomarker => (
              <Box as="li" key={biomarker} fontSize={[14, 14, 16]} fontFamily="gilroyMedium">
                {biomarker}
              </Box>
            ))}
          </Grid>
        </Box>
      ) : null}
    </Stack>
  );
}
